/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
if (!customElements.get('email-signup-block')) {
  class EmailSignupBlock extends HTMLElement {
    constructor() {
      super();
      /** @type {number} */
      this.lastButtonWidth = 0;
      /** @type {ResizeObserver | undefined} */
      this.observer = undefined;
      this.adjustInputPadding = this.adjustInputPadding.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.email-signup__button--integrated');
      this.input = this.querySelector('.email-signup__input');
      this.inputGroup = this.querySelector('.email-signup__input-group');

      const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

      if (this.button && this.input && this.inputGroup && isTextButton) {
        this.adjustInputPadding();

        this.observer = new ResizeObserver(() => {
          this.adjustInputPadding();
        });
        this.observer.observe(this.button);

        if ('fonts' in document) {
          document.fonts.ready.then(() => {
            this.adjustInputPadding();
          });
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    adjustInputPadding() {
      if (!this.button || !this.inputGroup) return;

      const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

      if (buttonWidth !== this.lastButtonWidth) {
        this.lastButtonWidth = buttonWidth;
        /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
      }
    }

  }

  customElements.define('email-signup-block', EmailSignupBlock);
}

// Gestionnaire de modale avec blocage du scroll
if (!window.__emailSignupModalInit) {
  window.__emailSignupModalInit = true;

  // Fonction pour bloquer/débloquer le scroll
  function toggleBodyScroll(disable) {
    if (disable) {
      // Sauvegarder la position actuelle du scroll
      const scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.dataset.scrollPosition = scrollY;

      document.body.classList.add('modal-open');
    } else {
      // Restaurer la position du scroll
      const scrollY = document.body.dataset.scrollPosition;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY));
      }
      delete document.body.dataset.scrollPosition;

      document.body.classList.remove('modal-open');
    }
  }

  // Ouvrir la modal si le formulaire vient d'être soumis avec succès
  function checkAndOpenModal() {
    if (window.location.search.includes('customer_posted=true')) {
      document.querySelectorAll('.email-signup-modal').forEach((modal) => {
        modal.removeAttribute('hidden');
        toggleBodyScroll(true);
      });
    }
  }

  checkAndOpenModal();

  // Observer les changements d'URL
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      if (url.includes('customer_posted=true')) {
        document.querySelectorAll('.email-signup-modal').forEach((modal) => {
          modal.removeAttribute('hidden');
          toggleBodyScroll(true);
        });
      }
    }
  }).observe(document, { subtree: true, childList: true });

  // Fermeture de la modal
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target.closest('.email-signup-modal__close') || target.classList.contains('email-signup-modal__overlay')) {
      const modal = target.closest('.email-signup-modal');
      if (modal) {
        modal.setAttribute('hidden', '');
        toggleBodyScroll(false);
      }
    }
  });

  // Fermeture avec la touche Echap
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.email-signup-modal:not([hidden])').forEach((modal) => {
        modal.setAttribute('hidden', '');
        toggleBodyScroll(false);
      });
    }
  });
}